export default __webpack_public_path__ + "static/media/151-health-care.0b7822ca.png";